import React from 'react';
import ScrollContainer from 'react-indiana-drag-scroll';

import SpaceY from '../../../../components/SpaceY';
import {
  MAX_WIDTH_639PX,
  s3CloudFrontUrlEndpoint,
} from '../../../../utils/common';
import { right_arrow_white_30x30 } from '../../../../utils/common/variables';
import { useAlertModal } from '../../../../utils/hook/hook';
import useClientMediaQuery from '../../../../utils/hook/useClientMediaQuery';

const SourcingLastSection = () => {
  const isMobile = useClientMediaQuery({ query: MAX_WIDTH_639PX });
  const { openAlertModal } = useAlertModal();

  const SLIDER_IMAGES = Array.from(
    { length: 2 },
    (_, i) =>
      `${s3CloudFrontUrlEndpoint}/mission/sourcing-slider-section3/${
        isMobile ? 'mo' : 'pc'
      }${i}.png`,
  );

  const MODAL_DATA = [
    {
      title: '김제 유기농 고구마 생산자님',
      content:
        '종자 심기를 할라면 빨리 판매가 되야하는데 판로 문제가 생겼어요. 유기농으로 정성껏 길렀는데 헐값에 처분해야하나 속앓이를 얼마나 했는지 모릅니다. 근데 너무 많은 분들이 구출에 참여를 해주셔서 힘든지도 모르고 열심히 수확하고 했습니다. 정성껏 기른 거를 알아주시는 분들의 식탁에 오를 수 있어 정말 감사했어요.',
    },
    {
      title: '여수 친환경 감자 생산자님',
      content:
        '내가 20년 넘게 농사 지으면서 내버린 감자만 해도 허벌져요. 매번 가슴이 을메나 미어졌는지.. 근디 일케 농민들 마음 알아주고 수고를 알아준다니까 얼마나 고마운지 몰러요. 지금이라도 만나서 참말 다행이고 반갑소!',
    },
  ];

  const handleOpenModal = (i: number) => openAlertModal({ ...MODAL_DATA[i] });

  return (
    <div className="bg-brand-10">
      <SpaceY height={72} />
      <h1 className="text-center text-30px font-bold leading-10 text-gray-800">
        산지에서 전하는 감사 인사
      </h1>

      <SpaceY height={40} />
      <div className="flex-center">
        <ScrollContainer className="flex flex-row gap-16px overflow-x-auto overflow-y-hidden whitespace-nowrap">
          <div className="h-px w-px shrink" />
          {SLIDER_IMAGES.map((imgUrl, i) => (
            <img
              key={imgUrl}
              onClick={() => handleOpenModal(i)}
              src={imgUrl}
              alt={`이미지 슬라이더 ${i}`}
              className="h-340px w-297px shrink cursor-pointer sm:h-404px sm:w-488px"
              loading="lazy"
            />
          ))}
          <div className="h-px w-px shrink" />
        </ScrollContainer>
      </div>

      <div className="px-16px">
        <SpaceY height={72} />
        <h3 className="text-22px font-bold text-gray-800 sm:text-center">
          생산자님이신가요?
        </h3>

        <SpaceY height={12} />
        <p className="text-18px leading-[28.8px] sm:text-center">
          구출이 필요한 농산물이 있다면 아래 링크를 통해 남겨주세요.
          {isMobile ? ' ' : <br />}
          빠른 시일 내에 연락드리겠습니다.
        </p>

        <SpaceY height={16} />
        <a
          target="_blank"
          rel="noreferrer"
          href={`https://docs.google.com/forms/d/e/1FAIpQLSc2cK1It5lbr4OzVaYET172RrRw5pYP67RUhO_6I-PfPgtrSQ/viewform`}
          className="flex-between mx-auto h-56px w-full max-w-[448px] rounded-[10px] bg-gray-600 px-20px"
        >
          <h4 className="text-22px font-bold text-white">농산물 납품 문의</h4>

          <img src={right_arrow_white_30x30} alt="오른쪽 화살표" className="" />
        </a>
      </div>

      <SpaceY height={72} />
    </div>
  );
};

export default SourcingLastSection;
